/* global Object */
/* global WeakMap */

let defaults = {
    threshold: 0
};

class LazyHandler {

    constructor(options) {

        this.settings = Object.assign({}, defaults, options);

        this.viewModels = new WeakMap();

        this.observer = new IntersectionObserver(this._checkElements.bind(this), {
            threshold: this.settings.threshold
        });

    }

    _checkElements(entries) {
        entries
            .filter(entry => entry.isIntersecting)
            .map(entry => this.viewModels.get(entry.target))
            .forEach(vm => vm && this.renderViewModel(vm));
    }

    addViewModel(vm) {
        this.viewModels.set(vm.$el, vm);
        this.observer.observe(vm.$el);
    }

    removeViewModel(vm) {
        this.observer.unobserve(vm.$el);
        return this.viewModels.delete(vm.$el);
    }

    renderViewModel(vm) {
        window.requestAnimationFrame(() => {
            vm.render();
            this.removeViewModel(vm);
        });
    }

}

export default LazyHandler;